<template>
  <div>
    <v-marker-cluster>
      <l-marker
        v-for="(latlng, i) in latLngs"
        :key="i"
        :icon="getIcon(latlng.weight)"
        :lat-lng="[latlng.lat, latlng.lng]"
      >
        <l-tooltip>{{ latlng.weight }}</l-tooltip>
      </l-marker>
    </v-marker-cluster>
  </div>
</template>

<script>
import { LMarker, LTooltip } from "vue2-leaflet";
import L from "leaflet";
import Vue2LeafletMarkerCluster from "vue2-leaflet-markercluster";
import "leaflet.markercluster";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import "leaflet/dist/leaflet.css"
import iconM from "@/assets/marker-icon-2x.png";
import iconShadow from "@/assets/marker-shadow.png";

export default {
  components: {
    LMarker,
    LTooltip,
    "v-marker-cluster": Vue2LeafletMarkerCluster,
  },

  props: {
    latLngs: {
      type: Array,
      default: () => [],
      custom: false,
    },
    weight: {
      type: Object,
      required: true,
    }
  },

  methods: {
    getIcon(weight) {
      let iconUrl = iconM;

      // Нормализуем вес для получения значения hue
      const normalizedWeight = Math.min(Math.max(weight, this.weight.minWeight), this.weight.maxWeight);
      const hue = ((normalizedWeight - this.weight.minWeight) / (this.weight.maxWeight - this.weight.minWeight)) * 120; // Оттенок от 0 до 120 (зеленый)

      const icon = L.divIcon({
        className: 'custom-icon',
        html: `<img src="${iconUrl}" style="filter: hue-rotate(${hue}deg); width: 26px; height: 41px;" />`,
        iconSize: [26, 41],
        iconAnchor: [13, 41],
        shadowUrl: iconShadow,
        shadowSize: [41, 41],
        shadowAnchor: [13, 41],
      });

      return icon;
    },
  }
};
</script>

<style>

.leaflet-tooltip-left {
  margin-top: 24px;
  margin-left: 12px;
}

.leaflet-tooltip-right {
  margin-top: 24px;
  margin-left: -10px;
}

.leaflet-tooltip-left:before {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 6px 6px 6px;
  border-color: transparent transparent #fff transparent;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
}

.leaflet-tooltip-right:before {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 6px 6px 6px;
  border-color: transparent transparent #fff transparent;
  top: 0px;
  left: 50%;
  transform: translateX(50%);
}

</style>
